import {Component, Input} from '@angular/core';

/**
 * Generated class for the ProfileAboutComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'profile-about',
  templateUrl: 'profile-about.html'
})
export class ProfileAbout {

  @Input() LOCAL;
  @Input() user;
  @Input() TBRPersonality;

  constructor() {
  }

  getNameFromLocal(object, key){
    if(object !== null){
      if(this.LOCAL == 'fr'){
        return object[key]
      }else{
        return object[key+'_'+this.LOCAL]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/profile/profile-about/profile-about.ts